// The WeChat module's texts, by tag (SPEC.md §14), and the texts of its error codes.
export const zh = {
  'button-enable-notify': '允许下一次微信提醒',
  'account-notify': '对手落子时通知我',
  'account-notify-hint': '关闭后，对手无法通知你，落子时也不再弹出微信提示',
  'notify-notice-title': '开启"轮到你"提醒？',
  'notify-notice-when': '对手落子后，如果你没在看这盘棋，慢棋会通过微信提醒你轮到你了。',
  'notify-notice-watching': '正在看棋时不会收到提醒。',
  'notify-notice-how': '微信询问时，勾选"总是保持以上选择"再点"允许"，就不会反复弹出。',
  'notify-notice-settings': '随时可在"设置"里开关。',
  'notify-notice-warning': '注意：勾选"总是保持"后点"取消"，以后将无法再开启提醒。',
  'notify-notice-on': '开启提醒',
  'notify-notice-off': '暂不开启',
  'notify-notice-rejected': '你在微信里取消了提醒，已为你关闭',
  'admin-notify-template': '提醒模板',
  'admin-notify-template-default': '默认',

  'button-wechat-sign-in': '微信登录',
  'wechat-your-name': '你的昵称',
  'button-wechat-confirm-name': '确定',
  'wechat-have-account': '已有慢棋账号？用邮箱登录',
  'wechat-link-hint': '登录后，此微信将绑定到该账号，以后在微信中自动登录',
  'account-wechat': '微信',
  'account-wechat-linked': '已绑定',
  'wechat-expired': '微信登录已超时，请重试',
  'error-wechat-failed': '微信登录失败，请重试',
  'error-wechat-already-linked': '该账号已绑定其他微信',
  'admin-wechat': '微信绑定',
  'admin-wechat-none': '还没有账号绑定微信',
  'admin-unlink-wechat': '解除绑定',
  'admin-wechat-unlink-confirm': '确定要解除{name}的微信绑定吗？',
  'admin-wechat-unlink-warning': '该账号没有邮箱，解除后将无法再使用',
  'create-opponent-invite-wechat': '邀请微信好友',
  'button-wechat-send-to-friend': '发给好友',
  'wechat-send-overlay': '点这里，选「发送给朋友」',
  'wechat-send-overlay-continue': '点任意处继续下棋',
  'wechat-send-overlay-close': '点任意处关闭',
  'game-share-title': '{name} 邀请你在慢棋下棋（第{id}局）',
  'invitation-share-title': '{name} 邀请你在慢棋下一盘围棋',
  'invitation-share-desc': '{grid}路，慢慢下，一天几步也行',
  'invitation-share-desc-handicap': '{grid}路{handicap}，慢慢下，一天几步也行',
};

export const errors = {
  'wechat-error': 'error-wechat-failed',
  'wechat-unavailable': 'error-wechat-failed',
  'wechat-already-linked': 'error-wechat-already-linked',
};
